import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageComments() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addReview({ _id, ...rest } = {}) {
    return privateFetch.post(`/v1/admin/comments/add`, rest).then((res) => res.data);
  }

  function updateReview({ _id, ...rest } = {}) {
    return privateFetch.put(`/v1/admin/comments/${_id}`, rest).then((res) => res.data);
  }

  function deleteReview({ _id } = {}) {
    return privateFetch.delete(`/v1/admin/comments/${_id}`).then((res) => res.data);
  }
  async function updateReply({ _id, ...data } = {}) {
    return privateFetch.put(`/v1/admin/comments/${_id}/reply`, data).then((res) => res.data);
  }

  function manageReply({ type, ...data }) {
    if (type === 'UPDATE') return updateReview(data);
    if (type === 'DELETE') return deleteReview(data);
    if (type === 'EDIT_BUTTON_CLICK_UNRESOLVED') return updateReply(data);
    if (type === 'MARK_AS_NOT_RESOLVED') return updateReview(data);

    return addReview(data);
  }

  return useMutation(manageReply, {
    onSuccess() {},
    onError() {},
    onSettled(data, error, variables) {
      queryClient.invalidateQueries('content-comments');
      queryClient.invalidateQueries('quiz-questions');
      queryClient.invalidateQueries('chapters');
      if (!variables?.topic) queryClient.invalidateQueries('topic-details');
      queryClient.invalidateQueries('chapter-mindmap');
    },
  });
}

export default useManageComments;
